import { Icon } from '@toggle/design-system';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { config } from '@/config/app.config';
import { createLogGA } from '@/utils/analytics/logGA';

import * as S from './TwitterLink.styles';

export interface TwitterLinkProps {
  assetName: string;
  reported: boolean;
  twitterMessage: {
    preReported: string;
    postReported: string;
  };
  url: string;
}

const logGA = createLogGA('Share');

export const TwitterLink = ({
  assetName,
  reported,
  twitterMessage,
  url,
}: TwitterLinkProps) => {
  const { t } = useTranslation('earnings');

  const text = reported
    ? twitterMessage.postReported
    : twitterMessage.preReported;
  const onClick = () => {
    logGA('share_analysis', { assetName, platform: 'twitter' });
  };

  return (
    <S.ExternalLink
      data-testid="twitter-link"
      as="a"
      href={`https://twitter.com/intent/tweet?url=${url}&text=${text}&via=${config.twitterUsername}&button_hashtag=earnings`}
      target="_blank"
      rel="noopener noreferrer"
      size="medium"
      variant="tertiary"
      onClick={onClick}
    >
      <S.Caption>
        <Icon iconName="TwitterColor" viewBox="0 0 48 48" size={16} />
        {t('earnings:twitterButton')}
      </S.Caption>
    </S.ExternalLink>
  );
};
